'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _parseBoolean = require('./utils/parseBoolean');

var _parseBoolean2 = _interopRequireDefault(_parseBoolean);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  fromTuneResponse: function fromTuneResponse(streams) {
    return streams.map(function (stream) {
      return {
        url: stream.url,
        reliability: stream.reliability,
        format: stream.mediaType.toLowerCase(),
        id: stream.guideId || undefined,
        nextGuideId: stream.nextGuideId || undefined,
        itemToken: stream.itemToken || undefined,
        position: stream.position || 0,
        requiresUnwrap: !!stream.isProxy,
        isLiveSeekStream: (0, _parseBoolean2.default)(stream.liveSeekStream),
        isHlsAdvanced: (0, _parseBoolean2.default)(stream.isHlsAdvanced),
        useStreamMetadata: (0, _parseBoolean2.default)(stream.useStreamMetadata)
      };
    });
  },
  /**
   * Function to map the unwrap stream response to an internal web-tuner
   * stream model.
   *
   * @param streams {array} an array of streams returned from the unwrap streams call
   * @param metadata {object} metadata that should be mapped to each stream. (ex. isLiveSeekStream)
   * @returns {array}
   */
  fromUnwrapResponse: function fromUnwrapResponse(streams) {
    var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return streams.map(function (stream) {
      return (0, _extends3.default)({
        url: stream.url,
        reliability: stream.reliability,
        format: stream.mediaType.toLowerCase(),
        id: 'e' + stream.streamId,
        requiresUnwrap: false
      }, metadata);
    });
  }
};
//# sourceMappingURL=streamMapper.js.map